import React, { Suspense } from 'react'
import Field from '../../../fields'
import { colors } from '@lmc/common/constants'

interface EmarMedicationInstructionsSectionProps {
  fields: Record<string, any>
  formId: string
  resident: Record<string, any>
  testId?: string
}

const renderCautionaryInstructionsField = (
  props: EmarMedicationInstructionsSectionProps
) => {
  const { fields, formId, testId } = props

  const title = 'Cautionary Instructions'
  const note =
    'Written on the pharmacy label. This will be shown to carers whilst they are administering medication.'

  const renderLabelChildren = () => <div style={styles.labelNote}>{note}</div>

  return (
    <div
      style={styles.fieldContainer}
      data-testid={
        testId
          ? `${testId}-cautionary-instructions-field`
          : 'cautionary-instructions-field'
      }
    >
      <Suspense fallback={<div>Loading...</div>}>
        <Field
          compact
          displayLabel
          fieldType="textarea"
          formId={formId}
          keys="cautionaryInstructions"
          layout="no-label"
          label={title}
          renderLabelChildren={renderLabelChildren}
          style={{ resize: 'none' }}
          type="userGeneratedFieldLayout"
          values={fields}
        />
      </Suspense>
    </div>
  )
}

const EmarMedicationInstructionsSection: React.FC<
  EmarMedicationInstructionsSectionProps
> = (props) => {
  const { testId } = props
  return (
    <div
      data-testid={
        testId ? `${testId}-cautionary-instructions` : 'cautionary-instructions'
      }
    >
      {renderCautionaryInstructionsField(props)}
    </div>
  )
}

const styles = {
  fieldContainer: {
    marginTop: 16
  },
  labelNote: {
    color: colors.darkgrey,
    fontSize: 12,
    lineHeight: '18px'
  }
}

export default EmarMedicationInstructionsSection
